import { api } from './api'
import type { Device, DeviceListResponse, LoginRequest, LoginResponse, Network, HeartbeatRequest } from '../types'

export const authService = {
  login: (data: LoginRequest) => api.postForm<LoginResponse>('/auth/login', data),
}

export const networkService = {
  getNetwork: () => api.get<Network>('/network'),
}

export const deviceService = {
  listDevices: (params?: { skip?: number; limit?: number; online?: boolean; search?: string }) => {
    const query = new URLSearchParams()
    if (params?.skip !== undefined) query.set('skip', String(params.skip))
    if (params?.limit !== undefined) query.set('limit', String(params.limit))
    if (params?.online !== undefined) query.set('online', String(params.online))
    if (params?.search) query.set('search', params.search)
    const qs = query.toString()
    return api.get<DeviceListResponse>(`/devices${qs ? `?${qs}` : ''}`)
  },
  getDevice: (id: string) => api.get<Device>(`/devices/${encodeURIComponent(id)}`),
  updateDevice: (id: string, data: Partial<Pick<Device, 'name' | 'description'>>) =>
    api.put<Device>(`/devices/${encodeURIComponent(id)}`, data),
  deleteDevice: (id: string) => api.delete<void>(`/devices/${encodeURIComponent(id)}`),
  sendHeartbeat: (id: string, data: HeartbeatRequest) =>
    api.post<Device>(`/devices/${encodeURIComponent(id)}/heartbeat`, data),
}
